// extracted by mini-css-extract-plugin
export var animateCircle = "alert-module--animate-circle--PQqfw";
export var body = "alert-module--body--OGSfM";
export var bounce = "alert-module--bounce--KVxsb";
export var fade = "alert-module--fade--KvYlo";
export var ldsRing = "alert-module--lds-ring--ONsdd";
export var linkCopy = "alert-module--linkCopy--92XOF";
export var text = "alert-module--text--WdS2e";